import cron from 'node-cron';
import { Container } from 'typedi';
import i18next, { TFunction } from 'i18next';
import { UserManagementService } from '../../Modules/userManagement/services/userManagement.service';
import User from '../../Modules/Auth/models/auth.model';
import { StatusEnum } from '../../Modules/Auth/interfaces/auth.interface';
import { TZ } from '../../config/index';
export class InvitationExpiryJob {
    public userService = Container.get(UserManagementService);

    public start() {
        cron.schedule('30 12 * * *', async () => {
            try {
                const t: TFunction = i18next.t.bind(i18next);
                console.log('⏰ Running InvitationExpiryJob');

                const expiredUsers = await User.find({
                    status: { $regex: new RegExp(`^${StatusEnum.WAITING_TO_ACCEPT}$`, 'i') },
                    isDeleted: false,
                    forgotpasswordTokenExpiry: { $lt: new Date() },
                    isFirstTimeResetPassword: true
                })
                    .populate('roleId')
                    .lean();

                for (const user of expiredUsers) {
                    try {
                        await this.userService.resendInvitation(user.email, user.createdBy.toString(), t);
                        console.log(`Invitation resent for user: ${user.email}`);
                    } catch (error) {
                        console.error(`Failed to resend invitation for user ${user.email}:`, error);
                    }
                }

                console.log(`Processed ${expiredUsers.length} expired invitations`);
            } catch (error) {
                console.error('Error in invitation expiry cron job:', error);
            }
        },
            { timezone: TZ });
    }
}